import React from 'react';
import { useData } from '../../Context/DataContext';
import PageHeader from '../../components/PageHeader/PageHeader';
import styles from './FailedPayouts.module.css';

const FailedPayouts = () => {
  const { failedPayouts, retryPayout } = useData();

  return (
    <>
      <PageHeader
        backTo="/payments"
        backText="← Payments"
        title="Failed payouts"
        subtitle="Transactions requiring beneficiary correction or retry."
      />

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Participant</div>
          <div>UPI ID</div>
          <div>Error reason</div>
          <div>Amount</div>
          <div>Action</div>
        </div>

        {failedPayouts.map((item) => (
          <div key={item.id} className={styles.tableRow}>
            <span className={styles.participantName}>{item.participant}</span>
            <span className={styles.upiText}>{item.upi}</span>
            <span className={styles.errorText}>{item.error}</span>
            <span className={styles.amountText}>{item.amount}</span>
            <div>
              <button
                type="button"
                onClick={() => retryPayout(item.id)}
                className={styles.actionBtn}
              >
                Retry
              </button>
            </div>
          </div>
        ))}

        {failedPayouts.length === 0 && (
          <div style={{ padding: '24px 18px', textAlign: 'center', color: '#6B7280', fontSize: '13px' }}>
            No failed payouts remaining.
          </div>
        )}
      </section>
    </>
  );
};

export default FailedPayouts;
